import { Component, Input, OnInit, OnDestroy, EventEmitter, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TransbankService } from 'src/app/services/transbank.service';
import { PagoService } from 'src/app/services/pago.service';
import { Pago } from 'src/app/models/pago.model';
import { FaseService } from 'src/app/services/fase.service';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { ProcesoMatriculaService } from 'src/app/services/procesomatricula.service';
import { Router } from '@angular/router';
declare var $: any;
declare var gtag;
declare var fbq;
@Component({
  selector: 'app-pago',
  templateUrl: './pago.component.html',
  styleUrls: ['./pago.component.css']
})

export class PagoComponent implements OnInit, OnDestroy {
  //urlSafepago: SafeResourceUrl;
  @Input() IdProceso: string = '';
  @Input() faseActual: string = '';
  @Input() ultimafase: number;
  @Output() Fase: EventEmitter<string> = new EventEmitter();
  PagoSubcribe: Subscription;
  Apagar: Pago;
  url = '';
  pago = false;
  procesar = false;
  cargandoFase = true;
  validandopago = false;
  confirmarMonto = false;
  constructor(
    private tbservice: TransbankService,
    public sanitizer: DomSanitizer,
    private pg: PagoService,
    private faseSubcribe: FaseService,
    private alerts: ToastrService,
    private procesoMatricula: ProcesoMatriculaService,
    private mtservice: ProcesoMatriculaService,
    private router: Router) {
    this.PagoSubcribe = this.faseSubcribe.fase$.subscribe(
      value => {
        if (value == '6') {
          if (this.ultimafase > 6) {
            this.Fase.emit('7');
            this.faseSubcribe.fase$.emit('7');
          } else {

            this.pg.GetPago(this.IdProceso).subscribe(
              (data: Pago) => {
                this.Apagar = data;
                const vSuma = data.Monto1 + data.Monto2;
                this.cargandoFase = false;
                if (vSuma <= 0) {
                  this.validandopago = true;
                  this.cargandoFase = true;
                  this.procesoMatricula.setFase(this.IdProceso, '7').subscribe((data) => {
                    this.loadPagoTag();
                    this.Fase.emit('7');
                    this.faseSubcribe.fase$.emit('7');
                  })
                }
                this.validandopago = false;
              },
              (err) => {
                // This is intentional
              }
            );
          }
        }
      }
    );
  }

  loadPagoTag() {
    gtag('event', 'conversion', {
      'send_to': 'AW-714382904/kiEsCJGw4N0BELi80tQC',
      'transaction_id': ''
    });
    fbq('track', 'Purchase');
  }

  ngOnInit(): void {
    // This is intentional
  }

  ngOnDestroy(): void {
    this.PagoSubcribe.unsubscribe();
  }

  CancelarMatricula() {
    this.procesar = true;
    this.alerts.info('Cancelando el proceso', 'Simulacion');

    this.mtservice.desactivaSimulacion(this.IdProceso).subscribe(
      (data) => {
        this.procesar = false;
        this.alerts.info('Esperar el redirecionamiento', 'Volviendo al inicio');
        $('#modal').modal('hide');
        this.router.navigateByUrl('/');
      },
      (err) => {
        this.alerts.error('Ha fallado la solicitud de cancelacion de proceso', 'Simulacion');
        this.procesar = false;
      }
    );


  }
  openModal() {
    $('#modal').modal('show');
  }
  getpago() {
    this.confirmarMonto = true;
    this.tbservice.getToken(this.IdProceso).subscribe(
      (data: any) => {
        this.pago = true;
        this.url = data.Url + '?token_ws=' + data.Token;
        console.log("this.url", this.url)

        this.confirmarMonto = false;
      },
      (err) => {
        this.alerts.error('Se ha perdido la coneccion con el servicio de pagos.. Notificar a Santo Tomas', 'Generacion del pago', { timeOut: 10000, positionClass: 'toast-bottom-right' });
        this.confirmarMonto = false;
      }
    );
  }

}
